import * as React from 'react';
import Tag from 'antd/lib/tag';
import { antGrey, runwayColors, tagStyle } from '../styles/globalStyles';

interface RolloutBadgeProps {
    isRolloutPaused: boolean;
}

export const RolloutBadge: React.FC<RolloutBadgeProps> = ({ isRolloutPaused }) => {
    if (!isRolloutPaused) {
        return null;
    }

    const rolloutBadge =
        isRolloutPaused ?
            { text: 'Paused', color: runwayColors.statusYellow }
        :   { text: 'Active', color: runwayColors.primary };

    return (
        <Tag
            style={{
                ...tagStyle,
                color: rolloutBadge.color,
                borderColor: rolloutBadge.color,
                backgroundColor: antGrey.grey2,
                marginInlineEnd: 0,
            }}
        >
            {rolloutBadge.text}
        </Tag>
    );
};
